let bsParams = {

    hjName:'',     // 奖项名称
    bzObject:'',     // 表彰对象
    commend:'',     // 奖励内容
    bjName:'',     // 颁奖单位
    hjLevel:'',     // 获奖级别
    hjLevelOther:'',
    hjDate:'',     // 表彰时间

    id:'',     // id
    publishMaterialId:'',     // publishMaterialId
    publishId:'',     // 出版单位ID


}

let paramsRule = {

	hjName:[
        { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
    ],     // 奖项名称
    bzObject:[
        { required:true, message:'请选择', trigger:'change' },
    ],     // 表彰对象
    commend:[
        { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
    ],     // 奖励内容
    bjName:[
        { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
    ],     // 颁奖单位
    hjLevel:[
        { required:true, message:'请选择', trigger:'change' },
    ],     // 获奖级别
    hjLevelOther:[
        { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
    ],
    hjDate:[
        { required:true, message:'请选择', trigger:'change' },
    ],     // 表彰时间

    id:'',     // id
    publishMaterialId:'',     // publishMaterialId
    publishId:'',     // 出版单位ID

}

export { bsParams,paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt5.js